const undo = {

	history: [],

	redoHistory: [],


	/**
	 * Add the current emoji art to the undo history.
	 * @return {void}
	 */
	add: function() {

		undo.history.push( undo.getArt() );
		undo.redoHistory = [];

		// Limit to 100 undo steps.
		if ( undo.history.length > 100 ) {
			undo.history.shift();
		}

	},


	/**
	 * Reset the undo history.
	 *
	 * @return {void}
	 */
	reset: function() {

		undo.history = [];
		undo.redoHistory = [];

		undo.add();

	},


	/**
	 * Undo the last action.
	 *
	 * @return {void}
	 */
	undo: function() {

		if ( undo.history.length > 0 ) {
			const last = undo.history.pop();
			undo.redoHistory.push( undo.getArt() );
			undo.setArt( last );
		}

	},


	/**
	 * Redo the last undo.
	 *
	 * @return {void}
	 */
	redo: function() {

		if ( undo.redoHistory.length > 0 ) {
			const last = undo.redoHistory.pop();
			undo.history.push( undo.getArt() );
			undo.setArt( last );
		}

	},


	/**
	 * Get the current emoji art.
	 *
	 * @return {array}
	 */
	getArt: function() {

		const { width, height, art } = ninjaData.data;

		const newArt = [];
		for ( let y = 0; y < height; y++ ) {
			newArt[ y ] = [];
			for ( let x = 0; x < width; x++ ) {
				newArt[ y ][ x ] = art[ y ][ x ];
			}
		}

		return newArt;

	},


	/**
	 * Set the current emoji art.
	 *
	 * @param {array} newArt
	 * @return {void}
	 */
	setArt: function( newArt ) {

		ninjaData.setData(
			{
				art: newArt,
			}
		);

	}

};